/**
 * Local calendar-date formatting.
 *
 * Use these INSTEAD of `date.toISOString().slice(0, 10)` / `.substring(0, 10)`.
 * `toISOString()` converts to UTC first, so in UTC+ timezones (e.g. Dubai UTC+4,
 * CEST UTC+2) it shifts local midnight on the 1st back to the previous day —
 * which is why the "this month" filter resolved to June 30 instead of July 1,
 * and why "today" defaults can land on yesterday in the early morning.
 *
 * Given a date, these read its LOCAL components, so they reflect the calendar
 * date the user sees. Called with no argument they return TODAY in Dubai days
 * (utils/datePresets.js businessDay()), whatever the browser's timezone. NOT for visiera platform timestamps (those have their own
 * Dubai-time handling via parseDateUTC/toDbDate) — only for UI dates, filter
 * presets, and today/current-month defaults.
 */

import { businessDay } from "@/utils/datePresets.js";

/**
 * A Date (or date-ish) → "YYYY-MM-DD" from its local components.
 * With NO argument: TODAY as the Dubai calendar day (2026-09-24) — the books
 * are kept in Dubai days, and a browser in Italy (or on UTC) would otherwise
 * default forms to the wrong day around midnight.
 */
export function toLocalYMD(d) {
  if (d === undefined) return businessDay().toISOString().slice(0, 10);
  const dt = d instanceof Date ? d : new Date(d);
  return [
    dt.getFullYear(),
    String(dt.getMonth() + 1).padStart(2, "0"),
    String(dt.getDate()).padStart(2, "0"),
  ].join("-");
}

/** A Date (or date-ish) → "YYYY-MM" from local components; no argument = this Dubai month. */
export function toLocalYM(d) {
  if (d === undefined) return businessDay().toISOString().slice(0, 7);
  const dt = d instanceof Date ? d : new Date(d);
  return [dt.getFullYear(), String(dt.getMonth() + 1).padStart(2, "0")].join("-");
}
